module.exports = __webpack_public_path__ + "assets/img/list-moreBtn-zh.33578f98.png";